export default __webpack_public_path__ + "static/media/9.9dcfcae5.jpg";